import { useCallback, useMemo, useState } from "react";
import { FORCED_HIDDEN_WHEN } from "./constants";

// v2: bumped when the visibility system changed (dependency cascading).
const HIDDEN_TYPES_KEY = "sceneElementsDiagram_hiddenTypes_v2";

export function useSceneGraphHiddenTypes() {
  const [hiddenTypes, setHiddenTypes] = useState(() => {
    try {
      const saved = localStorage.getItem(HIDDEN_TYPES_KEY);
      if (saved) {
        return new Set(JSON.parse(saved));
      }
    } catch {
      // Best-effort preference restore; fall back to the default visible set.
    }
    return new Set();
  });

  const toggleType = useCallback((type) => {
    setHiddenTypes((prev) => {
      const next = new Set(prev);
      next.has(type) ? next.delete(type) : next.add(type);
      try {
        localStorage.setItem(HIDDEN_TYPES_KEY, JSON.stringify([...next]));
      } catch {
        // Best-effort preference persistence.
      }
      return next;
    });
  }, []);

  // Derive the effective hidden set: add any types that are forced hidden
  // because their parent type is hidden. Used everywhere for layout + render.
  const effectiveHiddenTypes = useMemo(() => {
    const effective = new Set(hiddenTypes);
    Object.entries(FORCED_HIDDEN_WHEN).forEach(([parent, dependents]) => {
      if (effective.has(parent)) {
        dependents.forEach((d) => effective.add(d));
      }
    });
    return effective;
  }, [hiddenTypes]);

  return { hiddenTypes, effectiveHiddenTypes, toggleType };
}
